import { useMemo } from 'react'
import { serializeFormQuery, unicodeDecodeB64 } from '@/utils/helpers'
import { useLocation, useNavigate } from 'react-router-dom'
import { removePropertyEmpty } from '../utils'

export function useSearchParams() {
  const { search } = useLocation()
  const navigate = useNavigate()
  const searchParams = useMemo(() => parseUrlParamsToObject(search), [search])

  function parseUrlParamsToObject(urlQuery = search): Record<string, string> {
    if (!urlQuery) return {}

    try {
      const cleanParams = urlQuery.replace('?', '')
      const decodedParams = unicodeDecodeB64(cleanParams)
      const parsedParams: Record<string, string> = {}

      Object.keys(decodedParams).forEach((paramKey: any) => {
        try {
          parsedParams[paramKey] = JSON.parse(
            decodeURIComponent(decodedParams[paramKey])
          )
        } catch (error) {
          parsedParams[paramKey] = decodeURIComponent(decodedParams[paramKey])
        }
      })
      return parsedParams
    } catch {
      return {}
    }
  }

  function updateSearchParams(
    newParams: any,
    removeEmptyProps?: boolean,
    serializeQuery?: boolean
  ) {
    let urlSearchParams = { ...newParams }
    if (removeEmptyProps) urlSearchParams = removePropertyEmpty(urlSearchParams)
    if (serializeQuery)
      urlSearchParams = new URLSearchParams(serializeFormQuery(urlSearchParams))
    navigate({ search: urlSearchParams.toString() })
  }

  function includeParamsToUrl(paramsToAdd: Record<string, any>) {
    updateSearchParams({ ...searchParams, ...paramsToAdd }, true, true)
  }

  function cleanUrlParams() {
    navigate({ search: '' })
  }

  return {
    search,
    searchParams,
    updateSearchParams,
    parseUrlParamsToObject,
    includeParamsToUrl,
    cleanUrlParams
  }
}
